import React, { useState } from 'react';
import styled from 'styled-components';
import getBaseEditor, { CommandPanels } from '../../BaseEditor/index';
import { StyledLabel } from '../../BaseEditor/withLabel';
import TPs from './tp';

const DocGrid = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-column-gap: 2%;
  grid-row-gap: 5px;
`;

const DocGridAdapt = styled(DocGrid)`

  @media (max-width: 600px) {
  display: block;
  } 
`;
const DivElement = styled.div`
  grid-area: ${({ area }) => area};
`;

const GeneralTPColumnTypes = {
  account: { type: '/api/catalog/accounts/' },
  contract: { type: '/api/catalog/contracts/' },
  payer: { type: '/api/catalog/payers/' },
};
function EditorRenderer(getControl, {
  data, fields, dataSetter, options,
}) {
  const [typeView, setTypeView] = useState(true);
  const D = new Date(data.date);
  const localDate = D.toLocaleString('uk', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  const orderAmount = data.warehouse_set
    ? data.warehouse_set.reduce((sum, el) => sum + Number(el.order_amount), 0)
    : 0;

  const revenueAmount = data.warehouse_set
    ? data.warehouse_set.reduce((sum, el) => sum + Number(el.revenue_amount), 0)
    : 0;

  return (
    <>
      <StyledLabel>
        {`${options.name} ${data.id ? `#${data.id}` : ''} ${data.date ? `від ${localDate}` : ''} 
        Всього, до розмежування ${orderAmount.toFixed(2)}. 
        Всього, після розмежування ${revenueAmount.toFixed(2)}`}
      </StyledLabel>
      <StyledLabel>
        {`${data.account && data.account.kdb ? `КДБ ${data.account.kdb.repr}` : ''} `}
      </StyledLabel>
      <DocGridAdapt>
        <DivElement area="2/1">
          {getControl('date')}
        </DivElement>
        <DivElement area="2/2">
          {getControl('account', { backend: '/api/catalog/accounts/' })}
        </DivElement>
      </DocGridAdapt>
      <TPs.GeneralTP
        data={data.warehouse_set}
        options={fields.warehouse_set}
        onChange={(e, newRecs) => dataSetter({ warehouse_set: newRecs })}
        overrideColumns={GeneralTPColumnTypes}
        typeView={typeView}
        setTypeView={setTypeView}
        docId={data.id}
      />
    </>
  );
}
const CP = CommandPanels.docCommandPanel();
export default getBaseEditor(EditorRenderer, '/api/document/subscriptions/', CP);
